import { getVisitorId } from '../../shared/utilities/getVisitorId';
import { useCookie } from './useCookie';

export function useVisitorId() {
    const pcid = useCookie('_pcid');

    const atUserId = useCookie('atuserid');

    return getVisitorId({ atUserId, pcid });
}
